<template>
  <v-dialog v-model="value" persistent max-width="900px">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form" v-model="validForm">
        <v-container :style="'max-width:900px'">
          <v-layout wrap>

            <v-flex xs12 sm6 md6 v-if="isMM && !isClosed">
              <v-textarea
                :key="queryComponent"
                label="Query"
                v-model="item.comment"
                :rules="[(v) => !v && item.status == 'Open' ? 'Query is required' : true]"
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm6 md6 v-if="!isMM && !isClosed">
              <v-textarea
                :key="commentComponent"
                label="Comment"
                v-model="item.comment"
                :rules="[(v) => !v && item.status == 'Open' ? 'Comment is required' : true]"
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm4 md4 v-if="!isClosed">
              <v-select
              clearable
                label="Status"
                v-model="item.status"
                :items="['Open', 'Closed']"
                :rules="[v => !!v || 'Status is required']"
                @change="commentComponent++;queryComponent++"
              ></v-select>
            </v-flex>


            <v-flex xs12 sm2 md2 v-if="!isClosed">

                <v-tooltip top :disabled="!validForm">
                  <template slot="activator" slot-scope="{ on }">

                    <v-btn
                      class="mx-1 font-weight-light"
                      color="purple"
                      small
                      :disabled="!validForm"
                      @click="save()">
                      Save
                    </v-btn>

                  </template>
                  <span>Add</span>
                </v-tooltip>

            </v-flex>


          </v-layout>
        </v-container>
      </v-form>

      <v-divider></v-divider>

      <v-data-table
        :items="mmQueries"
        hide-actions
        :headers="[
          { text: 'Query/Comment', value: 'comment', sortable: false },
          { text: 'Status', value: 'status', sortable: false },
          { text: 'Insert at', value: 'insert_at', sortable: false },
          { text: 'Insert by', value: 'insert_by', sortable: false }
        ]"
      >
      <template slot="items" slot-scope="{ item }" >
        <td>{{ item.comment }}</td>
        <td>{{ item.status }}</td>
        <td>{{ item.insert_at }}</td>    
        <td>{{ item.insertby.name }} {{ item.insertby.surname }}</td>       
      </template>
    </v-data-table>


 
      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { getList, upsert, remove, post } from "@/api/base_api";
import { getNextQualityChecker } from "@/api/qualitycheck";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    itemEvent: Object,
    eventType: String
  },
  data() {
    return {
      validForm: true,
      validators,
      item: {},
      mmQueries: [],
      commentComponent:0,
      queryComponent:0
    };
  },
  mounted() {
    
  },
  watch: {
    value(v) {
      if (v) {        
        // this.item.eventId = this.itemEvent.id
        // this.item.eventType = this.eventType
        // this.item.adverse_event_id = this.itemEvent.id;
        this.item.protocol_id = this.itemEvent.protocol_id
        this.$refs.form.reset();     
        this.getData();   
      } else {
        // this.$refs.form.reset(); 
      }
    }
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return "Medical Monitor Query";
    },
    currentUserId() {
      return this.$store.getters.userObj.account_id
    },
    isMM() {
      return this.$store.getters.userObj.role == 'Medical Monitor'
    },
    idField() {
      return this.eventType + '_id'
    },
    isClosed() {
      const latest = this.mmQueries[this.mmQueries.length - 1]
      if (latest)
        return latest.status == 'Closed'
    }

  },
  methods: {
    getData() {
      const filter = {}
      filter[this.idField] = this.itemEvent.id
      getList('mm_query', filter, {rowsPerPage:-1}).then( data => {
        this.mmQueries = data.data;
      });
      
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }
      
      this.item.insertby_id = this.currentUserId;
      this.item[this.idField] = this.itemEvent.id;

      upsert('mm_query', this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "MM Query updated correctly",
            color: "success"
          });
          this.getData();
          this.$refs.form.reset()

          if(this.isMM) {
            post('/mm_changed', {id: this.itemEvent.id, 'mm_changed' : 1})
          }
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the MM Query update. " +
              e.response.data.message,
            color: "error"
          });
        });
    },
    // remove(item) {
    //   remove('mm_query', item.id)
    //     .then(data => {
    //       this.getData();
    //       this.item = {};
    //       this.item.eventId = this.itemEvent.id
    //       this.item.eventType = this.eventType
    //       this.item.insertby_id = this.currentUserId; 
    //     })
    // }
    
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
